import { usePreventScroll } from '@/hooks/usePreventScroll';
import { ExportInstructionPdfDialogProps } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { Drawer } from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';
import { Contents } from '../Contents';
import cx from 'classnames';
import styles from './styles.module.scss';

export const ExportInstructionPdfDialog: FC<ExportInstructionPdfDialogProps> =
  memo(({ open, onClose, payees, payeeQuery }) => {
    const containerRef = useGlobalContainerRef();
    const { t } = useTranslation();

    usePreventScroll(open);

    return (
      <Drawer
        visible={open}
        width={1120}
        onClose={onClose}
        title={t('export_instruction_pdf_dialog_title')}
        getContainer={containerRef}
        className={cx(styles.export_pdf_instruction_drawer)}
        mask
      >
        <Contents onClose={onClose} payees={payees} payeeQuery={payeeQuery} />
      </Drawer>
    );
  });

ExportInstructionPdfDialog.displayName = 'ExportInstructionPdfDialog';
